<template web>
  <div class="page-account-view page-notifications">

    <section class="bar theme-blue">
      <div class="container">
        <div class="bar-avatar">
          <span><img src="@/assets/img/agenda_details.svg" class="img_min"></span>
        </div>
        <h3 class="bar-firm-name">Agenda</h3>
        <br>
      </div>
    </section>

    <div class="notifications-index">
      <vue-element-loading :active="isLoading" spinner="spinner" color="#CE4169" />

      <div class="container bar-notifications">
        <div class="empty-state empty-state-notifications" v-if="!agendaItems.length && !isLoading">
          <div class="wrapper">
            <h4>¡No hay eventos en la agenda!</h4>
            <p>No se encontraron eventos programados en este momento.</p>
            <img src="@/assets/img/empty-states/no-hay-notificaciones.png" class="image-empty" alt="" v-if="imgNo">
          </div>
        </div>

        <template v-else>
          <div v-if="upcomingEvents.length">
            <h4 class="section-title-agenda">Próximos eventos</h4>
            <div
                v-for="notification in upcomingEvents"
                class="item-payment"
                :key="'up-' + notification.id"
            >
              <div class="details">
                <div class="status-bar" :class="getEventStatusClass(notification.start)"></div>
                <div class="notification-unread">
                  <div class="agenda-main-content">
                    <div class="agenda-title">{{ notification.title }}</div>
                    <div class="agenda-subtitle">
                      {{ notification.owners_association_name || 'General' }}
                    </div>
                  </div>
                  <div class="agenda-footer-content">
                    <div class="agenda-date">
                      <i class="fa fa-calendar"></i>
                      {{ notification.start | moment('DD/MM/YYYY') }} - {{ notification.start | moment('HH:mm') }} hs
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="pastEvents.length" style="margin-top: 30px;">
            <h4 class="section-title-agenda">Eventos pasados</h4>
            <div
                v-for="notification in pastEvents"
                class="item-payment"
                :key="'past-' + notification.id"
            >
              <div class="details">
                <div class="status-bar" :class="getEventStatusClass(notification.start)"></div>
                <div class="notification-unread">
                  <div class="agenda-main-content">
                    <div class="agenda-title">{{ notification.title }}</div>
                    <div class="agenda-subtitle">
                      {{ notification.owners_association_name || 'General' }}
                    </div>
                  </div>
                  <div class="agenda-footer-content">
                    <div class="agenda-date">
                      <i class="fa fa-calendar"></i>
                      {{ notification.start | moment('DD/MM/YYYY') }} - {{ notification.start | moment('HH:mm') }} hs
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import moment from 'moment';

export default {
  name: 'AgendaList',
  props: ['isLoading', 'imgNo'],
  data() {
    return {
      agendaItems: [],
    };
  },
  computed: {
    is_capacitor() {
      return (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios');
    },
    // Filtra: Eventos cuya hora de inicio es igual o posterior a AHORA MISMO
    upcomingEvents() {
      const now = moment();
      return this.agendaItems
          .filter(event => moment(event.start).isSameOrAfter(now))
          .sort((a, b) => new Date(a.start) - new Date(b.start));
    },
    // Filtra: Eventos cuya hora de inicio ya pasó respecto a AHORA MISMO
    pastEvents() {
      const now = moment();
      return this.agendaItems
          .filter(event => moment(event.start).isBefore(now))
          .sort((a, b) => new Date(b.start) - new Date(a.start));
    },
  },
  methods: {
    async loadEvents() {
      try {
        const events = await this.getAllEvents();
        this.agendaItems = events;
      } catch (error) {
        console.error('Error cargando la agenda:', error);
      }
    },
    getEventStatusClass(date) {
      const eventDate = moment(date).startOf('day');
      const today = moment().startOf('day');
      const now = moment();

      // Si el evento es hoy
      if (eventDate.isSame(today)) {
        // Si ya pasó de hora, lo ponemos gris (secondary), sino rojo (danger)
        return moment(date).isBefore(now) ? 'status-secondary' : 'status-danger';
      }

      if (eventDate.isAfter(today)) {
        return 'status-warning';
      }

      return 'status-secondary';
    },
  },
  async created() {
    await this.loadEvents();
  },
};
</script>

<style lang='scss' scoped>
/* Tu CSS se mantiene intacto */
.section-title-agenda {
  font-size: 14px;
  text-transform: uppercase;
  color: #888;
  margin: 20px 0 15px 5px;
  font-weight: bold;
}

.agenda-main-content {
  margin-bottom: 12px;
  padding-left: 15px;

  .agenda-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    display: block;
  }

  .agenda-subtitle {
    font-size: 13px;
    color: #777;
    margin-top: 2px;
  }
}

.agenda-footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f2f2f2;
  padding: 10px 0 0 15px;

  .agenda-date {
    font-size: 12px;
    color: #555;
    font-weight: 500;
  }
}

.status-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  padding: 3px !important;
}

.status-danger { background-color: #dc3545 !important; }
.status-warning { background-color: #ffc107 !important; }
.status-secondary { background-color: #6c757d !important; }

.item-payment {
  position: relative;
  background: white;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.notification-unread {
  width: 100%;
}
</style>
